import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { WithApp } from 'contexts/appContext';
import { makeStyles } from '@material-ui/core/styles';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { Link } from 'react-router-dom';

import { wsGetAll } from 'services/WService';

import {
  Add,
  Close,
  Edit,
  Smartphone,
  PersonRounded,
  AssignmentInd,
  Person,
  VerifiedUser,
  Settings,
  LocalShipping,
  AcUnit,
  MeetingRoom,
  Apps,
} from '@material-ui/icons';

import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Card from 'components/Card/Card';
import CardHeader from 'components/Card/CardHeader';
import CardBody from 'components/Card/CardBody';
import ReactTable from 'components/ReactTable/ReactTable.js';
import Button from 'components/CustomButtons/Button.js';
import Badge from 'components/Badge/Badge';
import CardIcon from 'components/Card/CardIcon';
import { wsImpersonate } from 'services/WService';
import UserAppModal from './UserAppModal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  input: {
    display: 'none'
  }
};

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 220 },
  { Header: 'Cod.', accessor: 'code', width: 100 },
  { Header: 'Nombre', accessor: 'name' },
  { Header: 'Email / DNI', accessor: 'email' },
  { Header: 'Tipo User', accessor: 'userLabelType', excelEnabled: false, width: 120 },
  { Header: 'Icono user', accessor: 'type', excelEnabled: false, width: 120 },
  { Header: 'Estado', accessor: 'state', excelEnabled: false, width: 110 },
  { Header: '', accessor: 'action', excelEnabled: false, width: 0 }
];

const useStyles = makeStyles(styles);

export default WithApp(function User(props) {
  const classes = useStyles();

  const [listUsers, setListUsers] = useState([]);
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [dataLoading, setDataLoading] = useState(false);

  async function getUsers() {
    setDataLoading(true);
    let response = await wsGetAll('oauth/user');
    setDataLoading(false);
    if (response.success) setListUsers(response.data);
  }

  async function impersonate(user) {
    setDataLoading(true);
    await wsImpersonate(user);
    setDataLoading(false);
  }

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <Card>
      <Toasty action={notify} />
      <UserAppModal model={model} setOpen={setOpen} showNotify={showNotify} />
      <CardHeader icon>
        <AllowedGuard
          permission={ConstantPermissions.OAUTH_USERS_STORE}
          component={
            <CardIcon color="primary">
              <PersonRounded style={{ color: 'white' }} />
            </CardIcon>
          }
        >
          <Link to="0">
            <CardIcon pointer="true" color="success">
              <Add style={{ color: 'white' }} />
            </CardIcon>
          </Link>
        </AllowedGuard>
        <h4 className={classes.cardIconTitle}>Listado de Usuarios {dataLoading && <LoadingSpinner />}</h4>
      </CardHeader>
      <CardBody>
        <ReactTable
          defaultWidth={1000}
          columns={columns}
          data={listUsers.map((item, i) => {
            const typeUser = filterUserType(item.type);
            return {
              num: (
                <div className="actions-right">
                  {i + 1}
                  <AllowedGuard permission={ConstantPermissions.OAUTH_USERS_UPDATE}>
                    <Link to={`${item.id}`}>
                      <Button justIcon round simple color={props.themeContext.buttonColorWarning}>
                        <Edit />
                      </Button>
                    </Link>
                  </AllowedGuard>
                  {/* Impersonar */}
                  <AllowedGuard permission={ConstantPermissions.OAUTH_USERS_UPDATE}>
                    <Button justIcon round simple color="success" onClick={() => impersonate(item)} disabled={item.type === 'A'}>
                      <MeetingRoom />
                    </Button>
                  </AllowedGuard>
                  {/* Accessos de aplicación */}
                  <AllowedGuard permission={ConstantPermissions.OAUTH_USERS_UPDATE}>
                    <Button justIcon round simple color="info"
                      onClick={() => {
                        setOpen({open: true, ...item});
                      }}
                    >
                      <Apps />
                    </Button>
                  </AllowedGuard>
                  <AllowedGuard permission={ConstantPermissions.OAUTH_USERS_DELETED}>
                    <Button justIcon round simple color={props.themeContext.buttonColorDanger}>
                      <Close />
                    </Button>
                  </AllowedGuard>
                </div>
              ),
              code: item.id,
              name: item.name,
              email: item.email,
              created: item.created_at,
              userLabelType: typeUser.label,
              type: <typeUser.type />,
              state: (
                <Badge color={item.state == 'A' ? 'success' : 'danger'}>
                  {item.state == 'A' ? 'Activo' : 'Inactivo'}
                </Badge>
              ),
              action: ''
            };
          })}
        />
      </CardBody>
    </Card>
  );
});

const filterUserType = (type) => {
  let userType = undefined;
  let userLabelType = '';
  switch (type) {
    case 'A': //Administrador
      userType = VerifiedUser;
      userLabelType = 'Administrador';
      break;
    case 'U': // user
      userType = Person;
      userLabelType = 'Usuario';
      break;
    case 'G':
      userType = AssignmentInd;
      userLabelType = 'Invitado';
      break;
    case 'I':
      userType = Settings;
      userLabelType = 'Interface';
      break;
    case 'S':
      userType = Smartphone;
      userLabelType = 'Vendedor';
      break;
    case 'JR':
      userType = LocalShipping;
      userLabelType = 'Jefe Reparto';
      break;
    default:
      userType = AcUnit;
      userLabelType = 'X';
  }

  return { type: userType, label: userLabelType };
};
